import React from 'react';
import Slider from 'react-slick';
import leafFlutteringInWind from 'assets/images/leaf-fluttering-in-wind.png';
import sneezingFace from 'assets/images/sneezing-face.png';
import baby from 'assets/images/baby.png';
import dogFace from 'assets/images/dog-face.png';
import construction from 'assets/images/construction.png';
import woman from 'assets/images/woman.png';
import explodingHead from 'assets/images/exploding-head.png';
import loadable from '@loadable/component';

const LazyImg = loadable(() => import('../common/LazyImg'));

const PrevArrow = props => {
  const { className, onClick } = props;
  return (
    <button type='button' className={`${className} filter-stats__slide-prev`} onClick={onClick} aria-label='Go to previous slide'>
      <svg className='icon icon-circle-left-arrow'><use xlinkHref='#icon-circle-left-arrow' /></svg>
      <span className='screen-reader-text'>Go to previous slide</span>
    </button>
  );
};
const NextArrow = props => {
  const { className, onClick } = props;
  return (

    <button type='button' className={`${className} filter-stats__slide-next`} onClick={onClick} aria-label='Go to next slide'>
      <svg className='icon icon-circle-right-arrow'><use xlinkHref='#icon-circle-right-arrow' /></svg>
      <span className='screen-reader-text'>Go to next slide</span>
    </button>
  );
};

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FilterStatsCarousel = props => (
  <Slider {...props.settings} className='filter-stats__carousel'>
    <div className='filter-stats__slide'>
      <h3 className='filter-stats__slide-title'>
        <LazyImg
          className='filter-stats__slide-image'
          src={leafFlutteringInWind}
          alt='leaf fluttering in wind'
        />
        {' '}
        The Basic Breather
      </h3>
      <div className='filter-stats__primary'>
        <h4 className='filter-stats__primary-title'>HEPA Filter</h4>
        <ul className='filter-stats__data-list'>
          <li className='filter-stats__data-item'>
            <strong>HEPA Class</strong>
            <span>H12</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>HEPA Efficiency</strong>
            <span>H12</span>
          </li>
        </ul>
      </div>
      <div className='filter-stats__secondary'>
        <h4 className='filter-stats__secondary-title'>Carbon Filter</h4>
        <ul className='filter-stats__data-list filter-stats__data-list--two-col'>
          <li className='filter-stats__data-item'>
            <strong>Carbon Blend</strong>
            <span>N/A</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>Carbon Weight</strong>
            <span>N/A</span>
          </li>
        </ul>
      </div>
    </div>
    <div className='filter-stats__slide'>
      <h3 className='filter-stats__slide-title'>
        <LazyImg
          className='filter-stats__slide-image'
          src={sneezingFace}
          alt='sneezing face'
        />
        The
        Big Sneeze
      </h3>
      <div className='filter-stats__primary'>
        <h4 className='filter-stats__primary-title'>HEPA Filter</h4>
        <ul className='filter-stats__data-list'>
          <li className='filter-stats__data-item'>
            <strong>HEPA Class</strong>
            <span>H13</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>HEPA Efficiency</strong>
            <span>H13</span>
          </li>
        </ul>
      </div>
      <div className='filter-stats__secondary'>
        <h4 className='filter-stats__secondary-title'>Carbon Filter</h4>
        <ul className='filter-stats__data-list filter-stats__data-list--two-col'>
          <li className='filter-stats__data-item'>
            <strong>Carbon Blend</strong>
            <span>N/A</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>Carbon Weight</strong>
            <span>N/A</span>
          </li>
        </ul>
      </div>
    </div>
    <div className='filter-stats__slide'>
      <h3 className='filter-stats__slide-title'>
        <LazyImg
          className='filter-stats__slide-image'
          src={dogFace}
          alt='dog face'
        />
        The Critter
        Cuddler
      </h3>
      <div className='filter-stats__primary'>
        <h4 className='filter-stats__primary-title'>HEPA Filter</h4>
        <ul className='filter-stats__data-list'>
          <li className='filter-stats__data-item'>
            <strong>HEPA Class</strong>
            <span>H13</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>HEPA Efficiency</strong>
            <span>H13</span>
          </li>
        </ul>
      </div>
      <div className='filter-stats__secondary'>
        <h4 className='filter-stats__secondary-title'>Carbon Filter</h4>
        <ul className='filter-stats__data-list filter-stats__data-list--two-col'>
          <li className='filter-stats__data-item'>
            <strong>Carbon Blend</strong>
            <span>Modified Granular Carbon</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>Carbon Weight</strong>
            <span>0.84 lb (381g)</span>
          </li>
        </ul>
      </div>
    </div>
    <div className='filter-stats__slide'>
      <h3 className='filter-stats__slide-title'>
        <LazyImg
          className='filter-stats__slide-image'
          src={baby}
          alt='baby'
        />
        The Rookie Parent
      </h3>
      <div className='filter-stats__primary'>
        <h4 className='filter-stats__primary-title'>HEPA Filter</h4>
        <ul className='filter-stats__data-list'>
          <li className='filter-stats__data-item'>
            <strong>HEPA Class</strong>
            <span>H12</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>HEPA Efficiency</strong>
            <span>H12</span>
          </li>
        </ul>
      </div>
      <div className='filter-stats__secondary'>
        <h4 className='filter-stats__secondary-title'>Carbon Filter</h4>
        <ul className='filter-stats__data-list filter-stats__data-list--two-col'>
          <li className='filter-stats__data-item'>
            <strong>Carbon Blend</strong>
            <span>Pure Granular Carbon</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>Carbon Weight</strong>
            <span>0.70 lb (318g)</span>
          </li>
        </ul>
      </div>
    </div>
    <div className='filter-stats__slide'>
      <h3 className='filter-stats__slide-title'>
        <LazyImg
          className='filter-stats__slide-image'
          src={construction}
          alt='construction'
        />
        The
        Home Wrecker
      </h3>
      <div className='filter-stats__primary'>
        <h4 className='filter-stats__primary-title'>HEPA Filter</h4>
        <ul className='filter-stats__data-list'>
          <li className='filter-stats__data-item'>
            <strong>HEPA Class</strong>
            <span>H12</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>HEPA Efficiency</strong>
            <span>H12</span>
          </li>
        </ul>
      </div>
      <div className='filter-stats__secondary'>
        <h4 className='filter-stats__secondary-title'>Carbon Filter</h4>
        <ul className='filter-stats__data-list filter-stats__data-list--two-col'>
          <li className='filter-stats__data-item'>
            <strong>Carbon Blend</strong>
            <span>Modified Granular Carbon</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>Carbon Weight</strong>
            <span>1.96 lb (889g)</span>
          </li>
        </ul>
      </div>
    </div>
    <div className='filter-stats__slide'>
      <h3 className='filter-stats__slide-title'>
        <LazyImg
          className='filter-stats__slide-image'
          src={woman}
          alt='woman'
        />
        The Mama-to-Be
      </h3>
      <div className='filter-stats__primary'>
        <h4 className='filter-stats__primary-title'>HEPA Filter</h4>
        <ul className='filter-stats__data-list'>
          <li className='filter-stats__data-item'>
            <strong>HEPA Class</strong>
            <span>H14</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>HEPA Efficiency</strong>
            <span>H14</span>
          </li>
        </ul>
      </div>
      <div className='filter-stats__secondary'>
        <h4 className='filter-stats__secondary-title'>Carbon Filter</h4>
        <ul className='filter-stats__data-list filter-stats__data-list--two-col'>
          <li className='filter-stats__data-item'>
            <strong>Carbon Blend</strong>
            <span>Pure Granular Carbon</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>Carbon Weight</strong>
            <span>0.70 lb (318g)</span>
          </li>
        </ul>
      </div>
    </div>
    <div className='filter-stats__slide'>
      <h3 className='filter-stats__slide-title'>
        <LazyImg
          className='filter-stats__slide-image'
          src={explodingHead}
          alt='exploding head'
        />
        The
        Overreactor
      </h3>
      <div className='filter-stats__primary'>
        <h4 className='filter-stats__primary-title'>HEPA Filter</h4>
        <ul className='filter-stats__data-list'>
          <li className='filter-stats__data-item'>
            <strong>HEPA Class</strong>
            <span>H14</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>HEPA Efficiency</strong>
            <span>H14</span>
          </li>
        </ul>
      </div>
      <div className='filter-stats__secondary'>
        <h4 className='filter-stats__secondary-title'>Carbon Filter</h4>
        <ul className='filter-stats__data-list filter-stats__data-list--two-col'>
          <li className='filter-stats__data-item'>
            <strong>Carbon Blend</strong>
            <span>Modified Granular Carbon</span>
          </li>
          <li className='filter-stats__data-item'>
            <strong>Carbon Weight</strong>
            <span>1.25 lb (567g)</span>
          </li>
        </ul>
      </div>
    </div>
  </Slider>
);

const FilterStats = () => {
  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    pauseOnFocus: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,

  };
  return (
    <section className='filter-stats'>
      <div className='container'>
        <div className='filter-stats__header'>
          <h2 className='filter-stats__title'>Filter specs at a glance.</h2>
          <h3 className='filter-stats__subtitle'>
            Curious about what goes into each filter? This handy chart is for
            you.
            {' '}
          </h3>
        </div>
        <div className='filter-stats__inner'>
          <table className='filter-stats__table responsive'>
            <tbody>
              <tr className='tr-exclude'>
                <td className='row-header'>&nbsp;</td>
                <td className='row-header'>&nbsp;</td>
                <td className='row-header'>&nbsp;</td>
              </tr>
              <tr className='tr-exclude'>
                <td className='row-header'>&nbsp;</td>
                <td className='row-header'><span className='row-header__value'>HEPA Filter</span></td>
                <td className='row-header'>
                  <span className='row-header__value'>Carbon Filter</span>
                </td>
              </tr>
              <tr className='tr-exclude'>
                <td className='row-header'>&nbsp;</td>
                <td className='row-header'>
                  <span className='row-subheader'>
                    <strong>HEPA Class</strong>
                    <strong>HEPA Efficiency</strong>
                  </span>
                </td>
                <td className='row-header'>
                  <span
                    className='row-subheader row-subheader--two-col'
                  >
                    <strong>
                      Carbon Blend
                    </strong>
                    <strong>
                      Carbon Weight
                    </strong>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className='row-label'>
                    <LazyImg
                      className='row-label__image'
                      src={leafFlutteringInWind}
                      alt='leaf-fluttering-in-wind'
                    />
                    The  Basic Breather
                  </span>
                </td>
                <td>
                  <span className='row-wrap'>
                    <span className='row-value'>H12</span>
                    <span
                      className='row-value'
                    >
                      99.6%
                    </span>
                  </span>
                </td>
                <td>
                  <span className='row-wrap row-wrap--two-col'>
                    <span className='row-value'>N/A</span>
                    <span
                      className='row-value'
                    >
                      N/A
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className='row-label'>
                    <LazyImg
                      className='row-label__image'
                      src={sneezingFace}
                      alt='sneezing face'
                    />
                    The Big Sneeze
                  </span>
                </td>
                <td>
                  <span className='row-wrap'>
                    <span className='row-value'>H13</span>
                    <span
                      className='row-value'
                    >
                      99.97%
                    </span>
                  </span>
                </td>
                <td>
                  <span className='row-wrap row-wrap--two-col'>
                    <span className='row-value'>N/A</span>
                    <span
                      className='row-value'
                    >
                      N/A
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className='row-label'>
                    <LazyImg className='row-label__image' src={baby} alt='baby' />
                    The Rookie Parent
                  </span>
                </td>
                <td>
                  <span className='row-wrap'>
                    <span className='row-value'>H12</span>
                    <span
                      className='row-value'
                    >
                      99.6%
                    </span>
                  </span>
                </td>
                <td>
                  <span className='row-wrap row-wrap--two-col'>
                    <span
                      className='row-value'
                    >
                      Pure Granular Carbon
                    </span>
                    <span className='row-value'>0.70 lb (318g)</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className='row-label'>
                    <img
                      className='row-label__image'
                      src={dogFace}
                      alt='dog-face'
                    />
                    The Critter Cuddler
                  </span>
                </td>
                <td>
                  <span className='row-wrap'>
                    <span className='row-value'>H13</span>
                    <span
                      className='row-value'
                    >
                      99.97%
                    </span>
                  </span>
                </td>
                <td>
                  <span className='row-wrap row-wrap--two-col'>
                    <span className='row-value'>Modified Granular Carbon</span>
                    <span
                      className='row-value'
                    >
                      0.84 lb (381g)
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className='row-label'>
                    <LazyImg
                      className='row-label__image'
                      src={construction}
                      alt='construction'
                    />
                    The Home Wrecker
                  </span>
                </td>
                <td>
                  <span className='row-wrap'>
                    <span className='row-value'>H12</span>
                    <span
                      className='row-value'
                    >
                      99.6%
                    </span>
                  </span>
                </td>
                <td>
                  <span className='row-wrap row-wrap--two-col'>
                    <span className='row-value'>Modified Granular Carbon</span>
                    <span
                      className='row-value'
                    >
                      1.96 lb (889g)
                    </span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className='row-label'>
                    <LazyImg className='row-label__image' src={woman} alt='woman' />
                    The Mama-to-Be
                  </span>
                </td>
                <td>
                  <span className='row-wrap'>
                    <span className='row-value'>H14</span>
                    <span
                      className='row-value'
                    >
                      99.995%
                    </span>
                  </span>
                </td>
                <td>
                  <span className='row-wrap row-wrap--two-col'>
                    <span
                      className='row-value'
                    >
                      Pure Granular Carbon
                    </span>
                    <span className='row-value'>0.70 lb (318g)</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span className='row-label'>
                    <img
                      className='row-label__image'
                      src={explodingHead}
                      alt='exploding-head'
                    />
                    The Overreactor
                  </span>
                </td>
                <td>
                  <span className='row-wrap'>
                    <span className='row-value'>H14</span>
                    <span
                      className='row-value'
                    >
                      99.995%
                    </span>
                  </span>
                </td>
                <td>
                  <span className='row-wrap row-wrap--two-col'>
                    <span className='row-value'>Modified Granular Carbon</span>
                    <span
                      className='row-value'
                    >
                      1.25 lb (567g)
                    </span>
                  </span>
                </td>
              </tr>
              <tr className='tr-exclude'>
                <td><span className='row-label'>&nbsp;</span></td>
                <td><span className='row-value'> </span></td>
                <td><span className='row-value'>&nbsp;</span></td>
              </tr>
            </tbody>
          </table>
          <p className='filter-stats__note'>*The Critter Cuddler also comes with a Mila Sock.</p>
        </div>
        <FilterStatsCarousel settings={settings} />
      </div>
    </section>
  );
};
export default FilterStats;
